module.exports = __webpack_public_path__ + "static/media/server-illustration-2.973a848d.svg";